import {
    ATTEMPT_FETCH_TEAMS,
} from 'shared_redux/actions';

export const fetchTeams = () => ({ type: ATTEMPT_FETCH_TEAMS });
